import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// utils
import { capitalize } from '../../../utils/text';

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import ReportService from '../../../services/ReportService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import DataTable from '../../../components/simple/dataTable/DataTable.js';
import Text from '../../../components/simple/text/Text'
import Anchor from '../../../components/simple/anchor/Anchor.js';
import ActionButton from '../../../components/compound/actionButton/ActionButton.js';


// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PulseLoader from 'react-spinners/PulseLoader.js'
import { isServiceAdmin } from '../../../utils/permissions.js';
import FormService from '../../../services/FormService.js';

function Logs (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [sort, setSort] = useState({
      property: 'reference',
      direction: 'desc'
    })

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')
    const params = useParams()
    const userId = params.userid

    const goBack = () => {
        navigate(-1)
    }     

    useEffect(() => {
        (async () => {
            if (!userId) { return }
            
            
            await getData()
            
    
            // setClickerValues(previousValues => ({
            // ...previousValues,
            // student: userId
            // }))

        })()
    }, [userId])

    const deleteReport = async submissionId => {
      if (window.confirm('Are you sure you want to delete this?')) {
        await FormService.updateSubmission(apiToken, submissionId, {
          status: 'Archived',
        });
        getData()
      }
    };

    const getData = async () => {
      setLoading(true)
      // let searchType = 'concernreport'
      // // if (isServiceAdmin()) {
      // //   searchType = 'globalIncidentSearch'
      // // }

      const results = await ReportService.getReport(
        apiToken,
        { 
          orgId: activeOrg.id,
          // limit: 100,
          // page: 1
        },
        {
          submissionType: 'concern',
          query: [
            {
              "key": "recordedBy",
              "operator": "is",
              "response": String(userId),
              "relation": null
            }
          ],
          reports: ['concernSearch'],
        },
      )

      if (results?.concernSearch) {
        setData(results.concernSearch)
      }

      setLoading(false)
    }

    let suTerm = capitalize(terms?.serviceUser || 'Service User')

    
     const resultColumns = [
         // {
         //   property: 'id',
         //   label: 'Concern No',
         //   header: <Text>Concern No</Text>,
         //   render: datum => (
         //     <Text>besmart: {JSON.stringify(datum)}</Text>
         //   )
         // },
          {
           property: 'concernDate',
           label: 'Child',
            header: <Text pad='none' margin='none' color='secondary' weight='800'>Date</Text>, 
           render: datum => (
            <Anchor href={`/log/${userId}/edit/${datum.id}`} color='primary'>
              <Text>{datum.concernDate || ''} {datum.concernTime || ''}</Text>
             </Anchor>
           )
         },
         {
           property: 'concern',
           label: 'Concern',
           header: <Text pad='none' margin='none' color='secondary' weight='800'>Communication</Text>,
            render: datum => (
             <Text>{datum.concern || ''}</Text>
           )
         },
     
         {
           property: 'type',
           label: 'Type',
           header: <Text pad='none' margin='none' color='secondary' weight='800'>Type</Text>,
            render: datum => (
             <Text>{datum.positiveNegative || ''}</Text>
           )
         },
     
         
         {
           property: 'action',
           label: 'Action',
           header: <Text pad='none' margin='none' color='secondary' weight='800'>Action</Text>,
            render: datum => (
             <Text>{datum.action || ''}</Text>
           )
         },
         {
           property: 'actionDate',
           label: 'Action Date',
           header: <Text pad='none' margin='none' color='secondary' weight='800'>Action Date</Text>,
            render: datum => (
             <Text>{datum.actionDate || ''} {datum.actionTime || ''}</Text>
           )
         },
          {
              property: 'actions',
              header: null,
              render: datum => (
                <>
                  <Box direction="row" width="100%">
                    {props?.type !== 'smartplan' && (
                      <ActionButton
                        onClick={() => {
                          navigate(`/log/${userId}/edit/${datum.id}`);
                        }}
                        target="_self"
                        plain
                        children={
                          <Box pad="5px">
                            <FontAwesomeIcon icon={['fal', 'edit']} color="#ff8300" />
                          </Box>
                        }
                      />
                    )}

                   {isServiceAdmin() && <ActionButton
                    target="_blank"
                    plain
                    onClick={() => {
                      deleteReport(datum.id);
                    }}
                    children={
                      <Box pad="5px">
                        <FontAwesomeIcon
                          icon={['fal', 'trash']}
                          color="#ff8300"
                        />
                      </Box>
                    }
                  />}
                  </Box>

                </>
              )
            }
          ]



  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Box
        gap='small'
        round='small'
        margin={{ horizontal: 'small', top: 'small' }}
      >
        <DataTable
          columns={resultColumns}
          data={data}
          border={{ color: '#ddd' }}
          primaryKey="id"
          step={250}
          paginate={true}
          sort={sort}
          onSort={setSort}
        />
        {!data.length && <Text>There are no results to display.</Text>}
      </Box>
    </Box>
  )
}
export default Logs
